import type { ReactNode } from "react"

import { PublicFooter } from "@/components/public-footer"
import { PublicHeader } from "@/components/public-header"

interface PublicLayoutProps {
  children: ReactNode
  headerVariant?: "brand" | "light"
}

export default function PublicLayout({
  children,
  headerVariant = "brand",
}: PublicLayoutProps) {
  return (
    <div className="app-canvas bg-surface-base flex min-h-screen flex-col">
      <svg
        width="0"
        height="0"
        style={{ position: "absolute" }}
        aria-hidden="true"
      >
        <filter id="canvas-grain">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.65"
            numOctaves={3}
            stitchTiles="stitch"
          />
        </filter>
      </svg>
      <PublicHeader variant={headerVariant} />
      <main className="flex-1">{children}</main>
      <PublicFooter />
    </div>
  )
}
